module.exports = __webpack_public_path__ + "img/discussion-b&w.629f1beb.svg";